(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["promo-bar"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    let CurrentTimeDate, ca_activate_time, ca_deactivate_time;
    CurrentTimeDate = new Date().getTime();
    if (document.querySelectorAll('[ca_activate_time]').length > 0) {
      ca_activate_time = new Date(
        document.querySelector('[ca_activate_time]').getAttribute('ca_activate_time')
      ).getTime();
      ca_deactivate_time = new Date(
        document.querySelector('[ca_deactivate_time]').getAttribute('ca_deactivate_time')
      ).getTime();
      if (CurrentTimeDate > ca_activate_time && CurrentTimeDate < ca_deactivate_time) {
        document.querySelector('.index-promo-section.cv-Canada').classList.remove('hidden');
      } else {
        document.querySelector('.index-promo-section.cv-Canada').classList.add('hidden');
      }
    }
    if (document.querySelectorAll('[usa_activate_time]').length > 0) {
      usa_activate_time = new Date(
        document.querySelector('[usa_activate_time]').getAttribute('usa_activate_time')
      ).getTime();
      usa_deactivate_time = new Date(
        document.querySelector('[usa_deactivate_time]').getAttribute('usa_deactivate_time')
      ).getTime();
      if (CurrentTimeDate > usa_activate_time && CurrentTimeDate < usa_deactivate_time) {
        document.querySelector('.index-promo-section.cv-USA').classList.remove('hidden');
      } else {
        document.querySelector('.index-promo-section.cv-USA').classList.add('hidden');
      }
    }
  });

  } catch(e) { console.error(e); }
})();
})();
